
export const assessment = {
  title: 'Avaliação Comportamental',
  instructions: 'Selecione todas as palavras que você sente que melhor te descrevem',
  selectWords: 'Selecione todas as palavras que você sente que melhor te descrevem:',
  progress: 'Progresso',
  complete: 'Completar Avaliação',
  selectedCount: 'Selecionadas',
  totalWords: 'Total de Palavras',
  startAssessment: 'Iniciar Avaliação',
  behavior: {
    title: 'Avaliação Comportamental',
    instruction: 'Selecione todas as palavras que você sente que melhor te descrevem',
    subtitle: 'Descubra seu estilo comportamental selecionando palavras que melhor te descrevem'
  },
  instructionCards: {
    selectWords: {
      title: 'Selecionar Palavras',
      description: 'Escolha todas as palavras que você sente que te descrevem melhor'
    },
    beAuthentic: {
      title: 'Seja Autêntico',
      description: 'Selecione palavras que realmente te representem'
    },
    takeYourTime: {
      title: 'Reserve Seu Tempo',
      description: 'Sem pressa - reflita sobre cada escolha'
    }
  },
  wordCounter: {
    selected: 'palavras selecionadas'
  },
  wordCategories: {
    dominance: 'Impulso',
    influence: 'Conexão',
    steadiness: 'Tarefa',
    conscientiousness: 'Ordem',
    objectivity: 'Estilo'
  },
  completion: {
    title: 'Avaliação Completa!',
    subtitle: 'Obrigado por completar a avaliação.',
    viewResults: 'Ver Resultados',
    downloadPDF: 'Baixar Relatório PDF'
  },
  stages: {
    self: {
      title: 'Avaliação de Comportamento Pessoal',
      subtitle: 'Como você se comporta naturalmente?',
      description: 'Selecione palavras que descrevem suas tendências comportamentais naturais e preferências',
      tip: 'Pense em como você age naturalmente quando está confortável e sendo você mesmo'
    },
    work: {
      title: 'Avaliação de Comportamento no Trabalho',
      subtitle: 'Como os outros esperam que você se comporte no trabalho?',
      description: 'Selecione palavras que descrevem como colegas, gestores e membros da equipe esperam que você aja profissionalmente',
      tip: 'Pense nas expectativas do ambiente de trabalho, não suas preferências comportamentais naturais'
    }
  },
  stageIndicator: {
    stage: 'Etapa',
    of: 'de'
  },
  controls: {
    continueToWork: 'Continuar para Comportamento no Trabalho',
    viewResults: 'Ver Resultados Combinados',
    continue: 'Continuar',
    viewResultsButton: 'Ver Resultados',
    selectMoreWords: 'Selecione {{count}} palavra{{plural}} a mais para continuar',
    selectAtLeast: 'Selecione pelo menos {{min}} palavras (mais {{remaining}})',
    selected: 'selecionadas',
    step: 'Etapa',
    of: 'de',
    processing: 'Processando...',
    minimumWords: 'Você precisa de no mínimo 8 palavras'
  },
  m3Instructions: {
    subtitle: 'Selecione palavras que te descrevem autenticamente e continue.',
    tip1: 'Escolha palavras que reflitam seu comportamento natural',
    tip2: 'Não existem respostas certas ou erradas',
    tip3: 'Leva cerca de 10 minutos',
    backToHome: 'Voltar para a página inicial',
    aiWarningTitle: 'Aviso de Integridade Acadêmica',
    aiWarningText: 'O uso de ferramentas de IA, assistência externa ou quaisquer recursos não autorizados é estritamente proibido. Nosso sistema monitora ativamente padrões irregulares. Candidatos que utilizarem IA ou ajuda externa serão imediatamente desqualificados.'
  },
  workBehavior: {
    title: 'Avaliação de Comportamento no Trabalho',
    description: 'Selecione palavras que descrevam como você se comporta no trabalho. Isso ajuda a identificar seu estilo de comportamento profissional.',
    selectWords: 'Selecione Palavras Que Descrevam Seu Comportamento no Trabalho',
    selectWordsSubtitle: 'Escolha palavras que melhor descrevam seu comportamento no trabalho'
  }
};
